<template>
  <div class="header lang-dir">
    <div class="content">
      <div class="next" @click="goback">
        <svg
          class="flip-dir"
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          fill="none"
        >
          <g clip-path="url(#clip0_316_676)">
            <path
              d="M15.787 7.48573L9.48393 1.18274C9.19995 0.898721 8.73944 0.898721 8.45542 1.18274C8.17139 1.46677 8.17139 1.92723 8.45542 2.21125L13.517 7.27288L0.727176 7.27356C0.325576 7.27356 0 7.59918 0 8.00083C0 8.40248 0.325673 8.7281 0.727321 8.72805L13.5168 8.72738L8.45547 13.7888C8.17144 14.0728 8.17144 14.5333 8.45547 14.8173C8.59743 14.9593 8.78356 15.0304 8.9697 15.0304C9.15583 15.0304 9.34196 14.9593 9.48393 14.8173L15.787 8.51424C15.9233 8.37785 16 8.19288 16 8C16 7.80713 15.9234 7.62211 15.787 7.48573Z"
              fill="white"
              fill-opacity="0.6"
            />
          </g>
          <defs>
            <clipPath id="clip0_316_676">
              <rect width="16" height="16" fill="white" />
            </clipPath>
          </defs>
        </svg>
      </div>
      <div class="label-container">
        <Icons icon="pa-user" height="20px" width="20px" />
        <div class="txt-container">
          <p class="tiny-title">
            {{ $t("personalArea.personalArea") }}:
            {{ $store.state.user.fullname }}
          </p>
          <p class="big-title">{{ title }}</p>
        </div>
      </div>
    </div>
    <div class="cancel">
      <Icons @click="close" icon="pa-cancel" height="16px" width="16px" />
    </div>
  </div>
</template>

<script>
import Icons from "../Icons/Icons.vue";
import menu from "@/services/menu";
export default {
  components: { Icons },
  props: ["title", "backurl"],
  methods: {
    close() {
      menu.closeMenu();
    },
    goback() {
      let url = this.backurl;
      if (!url) url = "personal-are-mainmenu";
      menu.openAt(url);
    },
  },
};
</script>

<style lang="scss" scoped>
.content * {
  margin: 0px;
}
.content {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 20px;
  flex-shrink: 0;
}
.cancel {
  display: flex;
  width: 16px;
  height: 16px;
  justify-content: center;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}
.header {
  display: flex;
  width: 323px;
  height: 56px;
  padding: 15px;
  justify-content: space-between;
  align-items: center;
  background: var(--custom-color1);
  position: sticky;
  top: 0px;
}
.next {
  display: flex;
  align-items: center;
}
.next:hover {
  stroke: white;
  font-weight: 700;
  cursor: pointer;
}
.cancel:hover {
  stroke: white;
  font-weight: 700;
  cursor: pointer;
}
.label-container {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  gap: 15px;
}
.txt-container {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  gap: 2px;
}
.tiny-title {
  color: #fff;
  font-size: 11px;

  font-weight: 400;
  line-height: 120%; /* 13.2px */
}
.big-title {
  color: #fff;
  font-size: 13px;
  font-weight: 700;
  line-height: 120%; /* 15.6px */
}
</style>
